import { Crosshair, Compass, Sparkles, HandHeart } from "lucide-react";
import useReveal from "../hooks/useReveal";

const blocks = [
    {
        icon: Crosshair,
        title: "Precisión quirúrgica",
        body: "Formado en el entorno más exigente de la medicina mexicana: el Hospital Central Militar (Universidad del Ejército y Fuerza Aérea), con residencia reconocida con Mención Honorífica. Entrenamiento adicional en cirugía laparoscópica avanzada por Stanford University e IRCAD Strasbourg.",
    },
    {
        icon: Compass,
        title: "Visión integral",
        body: "No trato enfermedades aisladas. Trato personas. Mi enfoque considera al paciente en su totalidad: biológica, metabólica y emocionalmente.",
    },
    {
        icon: Sparkles,
        title: "Innovación constante",
        body: "Miembro activo del American College of Surgeons (YFACS) y de la American Association of Parenteral and Enteral Nutrition (MASPEN), con actualización continua en laparoscopia avanzada y manejo metabólico.",
    },
    {
        icon: HandHeart,
        title: "Acompañamiento real",
        body: "Mi relación con el paciente no termina en el quirófano. El seguimiento postoperatorio es parte esencial de mi práctica y del éxito de cada resultado.",
    },
];

const Block = ({ icon: Icon, title, body, index }) => {
    const ref = useReveal();
    return (
        <div
            ref={ref}
            data-testid={`distintivo-block-${index}`}
            className="reveal relative p-8 lg:p-10 border border-navy/10 bg-white/40 hover:bg-white hover:border-gold/40 transition-all duration-500 group"
            style={{ transitionDelay: `${index * 100}ms` }}
        >
            <div className="absolute top-0 left-0 w-12 h-px bg-gold" />
            <div className="flex items-start gap-5">
                <div className="shrink-0 w-12 h-12 flex items-center justify-center text-gold border border-gold/30 group-hover:bg-navy group-hover:text-gold group-hover:border-navy transition-all duration-500">
                    <Icon size={22} strokeWidth={1.4} />
                </div>
                <div>
                    <h3 className="font-display text-2xl lg:text-[1.65rem] text-navy leading-tight">
                        {title}
                    </h3>
                    <p className="mt-3 text-sm lg:text-[15px] text-ink/75 leading-relaxed font-light">
                        {body}
                    </p>
                </div>
            </div>
        </div>
    );
};

const PorQue = () => {
    const headRef = useReveal();
    return (
        <section
            id="por-que"
            data-testid="por-que-section"
            className="py-24 lg:py-32 bg-cream"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <div ref={headRef} className="reveal max-w-2xl mb-16">
                    <div className="flex items-center gap-4 mb-6">
                        <span className="block w-16 h-px bg-gold" />
                        <span className="eyebrow">Por qué el Dr. Cárdenas</span>
                    </div>
                    <h2
                        data-testid="por-que-heading"
                        className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-navy"
                    >
                        Lo que <span className="italic text-navy/85">me distingue.</span>
                    </h2>
                </div>

                <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
                    {blocks.map((b, i) => (
                        <Block key={b.title} index={i} {...b} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PorQue;
